"use strict";

angular.module("preventUnsavedChanges", []);

require("./prevent-unsaved-changes.service.js");
require("./prevent-unsaved-changes.modal.js");
require("./prevent-unsaved-changes.directive.js");



//////////////////
// WEBPACK FOOTER
// ./core/prevent-unsaved-changes/prevent-unsaved-changes.module.js
// module id = 338
// module chunks = 0